<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
      <el-form-item label="部门名称">
        <el-input v-model="formLabelAlign.name" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbitr">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { iaaMaterialReportcreate, iaaMaterialReportupdate } from '@/api/TKreleaseGroup.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: { name: '' },
      alltype: null,
      ids: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    sumbitr() {
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.name == '') {
        this.$message.error('请输入部门名称')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.alltype == 1) {
        iaaMaterialReportcreate({ name: this.formLabelAlign.name }).then((res) => {
          console.log('res', res)
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.$emit('updatawe')
        })
      } else {
        iaaMaterialReportupdate({ name: this.formLabelAlign.name, id: this.ids }).then((res) => {
          console.log('res', res)
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$emit('updatawe')
        })
      }
    },
    send(type, item) {
      this.alltype = type
      // eslint-disable-next-line eqeqeq
      if (type == 2) {
        this.formLabelAlign.name = item.name
        this.ids = item.id
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
